import React from 'react'

function TenderTextVARV() {
    return (
        <embed src="\pdfs\EAT1.5.2_VA-RV_VA-RN_Rectangular_displacement_outlet_kr.pdf" width="100%" height="2100px" />
    )
}

export default TenderTextVARV